import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { CouponDetailsInterface, ProductInterface } from '../exports/Interfaces';

class CompanyManager {
  public async getFreeMenuItems(companyId: number): Promise<DataWrappedResponse<ProductInterface[]>> {
    if (typeof companyId !== 'number') {
      return {
        response: null,
        success: false,
        status: 400,
      };
    }

    return BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/free-eligible-products`,
    });
  }

  public async getPromoCodeDetails(
    companyId: number,
    code: string,
  ): Promise<DataWrappedResponse<CouponDetailsInterface>> {
    return BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/promo-codes/${code}`,
    });
  }
}

export default new CompanyManager();
